import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import Header from '../../common/Header';
import SupportNav from '.././SupportNav';


class ContactUsThankYou extends Component {

    constructor(props) {
		super(props);
		this.state = {
			flag: true,
		};
	}
	
	render() {

		return (
			<div className="contact-us">
				<SupportNav />
				
				<Header
					title="Contact Us"
					description="Thank you for contacting us!"
				/>
        </div>
			
		);
	}
};

export default branch({
}, ContactUsThankYou);


// WEBPACK FOOTER //
// ./src/pages/support/contactUs/ContactUsThankYou.js